import React from 'react';
import Slider from "react-slick";
import {Card, Button, Container, Row, Col} from "react-bootstrap"
import _ from 'lodash'

export default props => {
    const items = props.data

    const cards = items.map(item => {
        return (
            <Container className="my-5 home-content">
                        <div key={item.node.slug} className="home-div" dangerouslySetInnerHTML={{ __html: item.node.content }}></div>
            </Container>
        )
    })

    const sliderSettings = {
        dots: true,
        infinite: true,
        gap : 20,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2
    }
    
	return(
        <Container className="text-center my-5">
            <h3 className="mb-4">Realizing the potential of 5G</h3>
            {
                cards.length===0 && 
                <div className="no-posts">
                    <h5>No Posts Available</h5>
                </div>
            }
            {
                cards.length > 1 &&
                <Slider className="post-card-slider1" {...sliderSettings}>
                    {cards}
                </Slider>
            }
            {
                cards.length == 1 &&
                <Row className="post-card-slider1">
                    <Col sm="3"/>{ cards.map( card => <Col sm="6">{card}</Col> )}
                </Row>
            }
        </Container>
	)
}